import { useState, useEffect, useMemo } from 'react'
import { apiGet } from './Api_Functions'
import generatedGitInfo from '../../generatedGitInfo.json'

const VersionNum = ({ extraInfo = false }) => {
  const [versions, setVersions] = useState([])

  const getVersion = async () => {
    const result = await apiGet('micVersion')
    setVersions(result)
  }

  useEffect(() => {
    getVersion()
  }, [])

  const versionNum = useMemo(() => {
    return (versions ? versions.version_num : '')
  }, [versions])

  if (!extraInfo) {
    return versionNum
  }

  return versionNum + ' | S-' + (versions ? versions.gitCommitId : '') + ' | J-' + generatedGitInfo.gitCommitHash
}

export default VersionNum
